import { QueryVal } from 'Helpers/Query';
import React from 'react';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { navigateTo } from 'Helpers/Redirect';

export const usePasswordResetEmail = (resource, setAuthCollection) => {
  const { displayErrorMessage } = useSnackbarContext();
  const [loaded, setLoaded] = React.useState(false);
  const token = QueryVal('t');
  const isEmailStep = resource.type() === 'AuthPasswordResetEmail';

  const passTokenToServer = async (localToken) => {
    try {
      const [setNewPasswordResource] = await resource.relationship(fr.relationships.setNewPassword.name).link('related').get();
      setNewPasswordResource.attr('token', localToken);
      const coll = await setNewPasswordResource.submit();
      setAuthCollection(coll);
    } catch (err) {
      // bail to the password reset screen if the token is bad
      displayErrorMessage(err, err.errors ?? 'An error ocurred');
      navigateTo('/change-password');
    }
    setLoaded(true);
  };

  React.useEffect(() => {
    if (token && isEmailStep) {
      passTokenToServer(token);
    } else {
      setLoaded(true); // Must be in an else because useEffect can't return early
    }
  }, [token, isEmailStep]);

  return loaded;
};
